// APIs
import IncidentClient from "@common/api/IncidentClient";

// Actions
import CustomerFormAction from "@common/redux/actions/CustomerFormAction";

// Hooks
import { useFormContext } from "react-hook-form";
import useLogin from "@common/components/hooks/useLogin";
import useSuspiciousActivity from "./useSuspiciousActivity";
import useComplianceAlerts from "./useComplianceAlerts";

// Helpers
import { suspiciousActivityCreatePayload } from "@common/components/helpers/SuspiciousActivity/suspiciousActivitySubmission";
import { handleError } from "@common/components/helpers/error";
import { parseSuspiciousActivityResponse } from "@common/components/helpers/compliance";
import { fetchSuspiciousActivityMetaData } from "../helpers/SuspiciousActivity/fetchSuspiciousActivityData";
import { useEffect } from "react";
import useCompliance from "./useCompliance";
import useLinkedAlert from "./useLinkedAlert";

const useSuspiciousActivityForm = () => {
  const methods = useFormContext();
  const [{ isDesktop, optionDisplaySessionsInCompliance }] = useLogin();

  const {
    reset,
    formState: { isValid, errors },
  } = methods;
  const data = useSuspiciousActivity();
  const {
    complianceAlertId,
    types,
    formData: { linkSessionEnabled },
  } = data;
  const setCustomerFormState = (data) => CustomerFormAction.dispatch(data);
  const { clearAlerts } = useComplianceAlerts();
  const { linkedAlertData } = useLinkedAlert();
  const { resetComplianceForms, submitComplianceForm } = useCompliance();

  const [policeInvolved, servicesDidNotAttend] = methods.watch([
    "policeInvolved",
    "servicesDidNotAttend",
  ]);

  useEffect(() => {
    setCustomerFormState({ formType: "suspiciousActivity" });
  }, []);

  const resetForm = (redirect) => {
    resetComplianceForms(redirect);
    fetchSuspiciousActivityMetaData();
  };

  const onSubmit = (data) => {
    if (!isValid) {
      console.error(errors);
      handleError(errors, "Error", "The submitted values are not valid!");
      return;
    }

    const payload = suspiciousActivityCreatePayload(data, linkedAlertData);

    const callback = complianceAlertId
      ? clearAlerts([complianceAlertId], false)
      : () => {};

    submitComplianceForm({
      client: IncidentClient,
      payload,
      resetForm,
      callback,
      desktopCallback: (response) =>
        reset(parseSuspiciousActivityResponse(response)),
    });
  };

  const onError = (errors) => console.error("Submit errors ", errors);

  return {
    ...data,
    policeInvolved,
    servicesDidNotAttend,
    onSubmit,
    onError,
    resetForm,
    methods,
    types,
    linkSessionEnabled,
    isDesktop,
    optionDisplaySessionsInCompliance,
  };
};

export default useSuspiciousActivityForm;
